import React from 'react';

const LogoAppStore = () => (
  <svg
    fill="none"
    height={20}
    viewBox="0 0 17 20"
    width={17}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.0864 3.19353C11.7029 2.44568 12.1374 1.42496 12.1374 0.394138C12.1374 0.252653 12.1273 0.111167 12.1071 0C11.0965 0.0404245 9.88378 0.667004 9.16625 1.51592C8.5902 2.16271 8.06468 3.19353 8.06468 4.22436C8.06468 4.38605 8.095 4.53765 8.1051 4.58818C8.16574 4.59828 8.2668 4.61849 8.37797 4.61849C9.27741 4.61849 10.4093 4.01213 11.0864 3.19353ZM11.7938 4.83072C10.288 4.83072 9.05508 5.75038 8.2668 5.75038C7.42799 5.75038 6.33653 4.89136 5.02274 4.89136C2.52653 4.89136 0 6.95301 0 10.8338C0 13.2592 0.929762 15.8161 2.09197 17.4634C3.08236 18.858 3.95149 20 5.20465 20C6.43759 20 6.98333 19.1814 8.51945 19.1814C10.0758 19.1814 10.4295 19.9798 11.7938 19.9798C13.1481 19.9798 14.0475 18.7367 14.9065 17.5139C15.8565 16.1091 16.2607 14.7448 16.2708 14.6741C16.19 14.6539 13.6028 13.5927 13.6028 10.6316C13.6028 8.06468 15.6342 6.91258 15.7554 6.82163C14.4113 4.89136 12.3598 4.83072 11.7938 4.83072Z"
      fill="white"
    />
  </svg>
);

export default LogoAppStore;
